import axios from 'axios';
import { SystemErrors } from 'typings';

const AUTH_FAILED_EVENT = new Event('auth-failed');

const axiosConfig = {
  baseURL: `${process.env.REACT_APP_CORE_API_URL || 'api'}/api/concierge`,
  timeout: 20000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
};

const httpClient = axios.create(axiosConfig);
httpClient.defaults.headers.post['Content-Type'] = 'application/json';
httpClient.defaults.headers.post.accept = 'application/json';

const handleAuthFailure = (err: any) => {
  if (err.response) {
    // the request was made and the server responded with a status code
    if (err.response.status === 401) {
      window.dispatchEvent(AUTH_FAILED_EVENT);
    }
  }

  return Promise.reject(err);
};

httpClient.interceptors.response.use((response) => response, handleAuthFailure);

export async function deleteRequest(
  url: string,
  config = {},
  systemError: string = SystemErrors.CORE_API
) {
  try {
    const { data } = await httpClient.delete(url, config);

    return data;
  } catch (e: any) {
    const { data, status: statusCode } = e.response || {};

    const errorPayload = {
      error: { data, statusCode, systemError },
    };

    throw errorPayload;
  }
}

export async function fetchRequest(
  url: string,
  config = {},
  systemError: string = SystemErrors.CORE_API
) {
  try {
    const { data } = await httpClient.get(url, config);
    return data;
  } catch (e: any) {
    const { data, status: statusCode } = e.response || {};

    const errorPayload = {
      error: { data, statusCode, systemError },
    };

    throw errorPayload;
  }
}

export async function postRequest(
  url: string,
  payload = {},
  config = {},
  systemError: string = SystemErrors.CORE_API
) {
  try {
    const { data } = await httpClient.post(url, payload, config);

    return data;
  } catch (e: any) {
    const { data, status: statusCode } = e.response || {};

    const errorPayload = {
      error: { data, statusCode, systemError },
    };
    throw errorPayload;
  }
}

export async function patchRequest(
  url: string,
  payload = {},
  config = {},
  systemError: string = SystemErrors.CORE_API
) {
  try {
    const { data } = await httpClient.patch(url, payload, config);

    return data;
  } catch (e: any) {
    const { data, status: statusCode } = e.response || {};

    const errorPayload = {
      error: { data, statusCode, systemError },
    };

    throw errorPayload;
  }
}

export default httpClient;
